import { Stack } from "@mui/material";
import { Table } from "components";
import { LoadingOrEmptyWrapper } from "components/LoadingAndEmptyHandler";

// TODO: Replace with getTableTypicalColumn type when it's ts
type CatalogTableHeader = {
  dataKey: string;
  isInDefault: boolean;
  label: string;
  valueTransformation: (row: Record<string, unknown>) => unknown;
};

type CatalogTablePanelProps<Row extends { id: number | string }> = {
  columnsMinWidth?: string;
  data: Row[];
  headers: CatalogTableHeader[];
  idColumnName: keyof Row & string;
  isLoading: boolean;
};

export const CatalogTablePanel = <Row extends { id: number | string }>({
  columnsMinWidth = "9rem",
  data,
  headers,
  idColumnName,
  isLoading,
}: CatalogTablePanelProps<Row>) => {
  return (
    <LoadingOrEmptyWrapper showEmpty={data.length === 0} showLoading={isLoading}>
      <Stack className="h-full w-full flex-col overflow-hidden">
        <Table
          className="flex-1"
          columnsMinWidth={columnsMinWidth}
          containedScroll
          data={data}
          editable={() => false}
          headers={headers}
          idColumnName={idColumnName}
          rowRemoveable={() => false}
        />
      </Stack>
    </LoadingOrEmptyWrapper>
  );
};
